/** @jsx jsx */
import { Box, Container, Grid } from '@bottlebooks/gatsby-design-system';
import EventBanner from '@bottlebooks/gatsby-theme-event/src/components/Event/EventBanner';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout/Layout';
import type { ContentLocale } from '@bottlebooks/gatsby-theme-event/src/useLocale';
import { graphql } from 'gatsby';
import type { ComponentPropsWithoutRef } from 'react';
import React from 'react';
import { Helmet } from 'react-helmet';
import { jsx } from 'theme-ui';
import type { EventBannerData } from '../@bottlebooks/gatsby-theme-event/components/Event/types';
import ConstrainedImage from './ConstrainedImage';

export default function AnnouncementPage({
  data: collection,
  locale,
  title,
  children,
}: {
  data: AnnouncementPageData | undefined;
  locale: ContentLocale;
  children: React.ReactNode;
  title: string;
}) {
  return (
    <Layout locale={locale} sx={{ backgroundColor: 'white' }}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <EventBanner
        event={collection}
        sx={{ maxHeight: 200, overflow: 'hidden' }}
      />
      {/** @ts-expect-error the JSDoc isn't correct. */}
      <Container sx={{ paddingTop: 3 }}>
        <Announcement>{children}</Announcement>
      </Container>
    </Layout>
  );
}

export function Announcement({
  children,
  ...rest
}: { children: React.ReactNode } & ComponentPropsWithoutRef<typeof Grid>) {
  return (
    // @ts-expect-error the JSDoc isn't correct.
    <Grid columns={[1, 2]} sx={{ gap: 4, alignItems: 'center' }} {...rest}>
      <Box sx={{ paddingY: 3, order: [null, 1] }}>{children}</Box>
      <ConstrainedImage
        publicId="/sites/best-of-burgenland-2023/BestOfBurgenland-Announcement.jpg"
        options={{
          width: 350,
          gravity: 'center',
          crop: 'pad',
          dpr: 3,
          fetchFormat: 'auto',
          quality: 'auto',
        }}
        sx={{}}
      />
    </Grid>
  );
}

export type AnnouncementPageData = EventBannerData;

export const fragment = graphql`
  fragment BestOfBurgenland_AnnouncementPage on Bottlebooks_Collection {
    ...bb_EventBannerImage
  }
`;
